module.exports = __webpack_public_path__ + "img/375_nav_img3.a249b4fe.png";